import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "bootstrap";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { FaStar } from "react-icons/fa";
import ServiceCarousel from "../Modals/ServiceCrousel";
import { fetchLatestReviews } from "../../reduxToolkit/Slices/ReviewAndRating/reviewRatingApis";

const CustomPrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev" onClick={onClick}>
    <i class="fa-solid fa-angle-left"></i>
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div className="custom-arrow next" onClick={onClick}>
    <i class="fa-solid fa-angle-right"></i>
  </div>
);

const Main = () => {
  const {
    getBirthdayList,
    getAnniversaryList,
    getKidsList,
    getWeddingDecoList,
    getCategoryList,
    getDealBannerList,
    getTopBannerList,
    loader,
  } = useSelector((state) => state.productList);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [scrollPosition, setScrollPosition] = useState(0);
  const scrollContainerRef = useRef(null);
  const [reviews, setReviews] = useState([]);

  // For reviews slider navigation
  const reviewsScrollRef = useRef(null);
  const handleReviewsScrollLeft = () => {
    if (reviewsScrollRef.current) {
      reviewsScrollRef.current.scrollBy({ left: -400, behavior: 'smooth' });
    }
  };
  const handleReviewsScrollRight = () => {
    if (reviewsScrollRef.current) {
      reviewsScrollRef.current.scrollBy({ left: 400, behavior: 'smooth' });
    }
  };

  // For FAQ toggle
  const [activeFaq, setActiveFaq] = useState(null);
  const handleFaqToggle = (idx) => {
    setActiveFaq(activeFaq === idx ? null : idx);
  };

  const { latestReviews = [], loading, error } = useSelector(
    (state) => state.reviews
  );

  //Fetching the Latest Reviews
  useEffect(() => {
    dispatch(fetchLatestReviews());
  }, [dispatch]);

  console.log("Latest Reviews:", latestReviews);
  const handleScrollLeft = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollAmount = container.offsetWidth * 0.8;
      container.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleScrollRight = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollAmount = container.offsetWidth * 0.8;
      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      setScrollPosition(scrollContainerRef.current.scrollLeft);
    }
  };

  const anniversaryScrollRef = useRef(null);
  const kidsScrollRef = useRef(null);
  const babyShowerScrollRef = useRef(null);

  const handleAnniversaryScrollLeft = () => {
    if (anniversaryScrollRef.current) {
      const container = anniversaryScrollRef.current;
      const scrollAmount = container.offsetWidth * 0.8;
      container.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleAnniversaryScrollRight = () => {
    if (anniversaryScrollRef.current) {
      const container = anniversaryScrollRef.current;
      const scrollAmount = container.offsetWidth * 0.8;
      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleKidsScrollLeft = () => {
    if (kidsScrollRef.current) {
      const container = kidsScrollRef.current;
      const scrollAmount = container.offsetWidth * 0.8;
      container.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleKidsScrollRight = () => {
    if (kidsScrollRef.current) {
      const container = kidsScrollRef.current;
      const scrollAmount = container.offsetWidth * 0.8;
      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleBabyShowerScrollLeft = () => {
    if (babyShowerScrollRef.current) {
      const container = babyShowerScrollRef.current;
      const scrollAmount = container.offsetWidth * 0.8;
      container.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleBabyShowerScrollRight = () => {
    if (babyShowerScrollRef.current) {
      const container = babyShowerScrollRef.current;
      const scrollAmount = container.offsetWidth * 0.8;
      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

const faqItems = document.querySelectorAll('.faq-item');
faqItems.forEach(item => {
  const questionBtn = item.querySelector('.faq-question');
  const icon = item.querySelector('.faq-icon');
  questionBtn.onclick = () => {
    const isActive = item.classList.toggle('active');
    icon.textContent = isActive ? '-' : '+';
  };
});

  const selectCity = window.localStorage.getItem("LennyCity");
  // const userDetail = JSON.parse(window.localStorage.getItem("LennyUserDetail"));

  const handleCategory = (item, subCat) => {
    navigate("/products", { state: { item, subCat, selectCity } });
    window.scrollTo({ top: 150, behavior: "smooth" });
  };

  const handleProduct = (item) => {
    navigate("/products/product-details", { state: item });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const settings = {
    infinite: true,
    loop: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    rewind: true,
    autoplay: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  const settings1 = {
    infinite: false,
    loop: false,
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
  };

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleIndicators");
    if (myCarousel) {
      new Carousel(myCarousel, {
        interval: 5000,
        pause: false,
        ride: "carousel", // Ensure autoplay starts
      });
    }
  }, []);

  console.log({ getBirthdayList });

  console.log({ getDealBannerList });

  return (
    <>
      <div className="Hero-Section">
        <div className="cards">
          <div className="card1">
            {/* <img src="https://cheetah.cherishx.com/website_layout/ganpati_menu_icon_desk.jpg?format=avif" alt="" /> */}
             <img src={require("../../assets/images/on.png")} />
            <p>Birthday</p>
          </div> 
          <div
            className="card1"
            style={{ cursor: "pointer" }}
            onClick={() => handleCategory({ categoryName: "KIDS BIRTHDAY" })}
          >
            {/* <img
              src="https://cheetah.cherishx.com/website_layout/1755324921__original_layout_55.jpg?format=avif"
              alt="Kids Birthday"
            /> */}
            <img src={require("../../assets/images/td.png")} />
            <p>
              Balloon <br />  bouquet
            </p>
          </div>
          {/* <div className="card1">
            <img src="https://cheetah.cherishx.com/website_layout/1737544205__original_layout_55.jpg?format=avif" alt="" />
                
            <p> Same day <br /> Decoration</p>
          </div> */}
          <div
            className="card1"
            style={{ cursor: "pointer" }}
            onClick={() => handleCategory({ categoryName: "BIRTHDAY" })}
          >
            {/* <img
              src="https://cheetah.cherishx.com/website_layout/120x86_Icons_Desktop_03_20241018_123157.jpg?format=avif"
              alt="Birthday Decoration"
            /> */}
               <img src={require("../../assets/images/thd.png")} />
            <p>
              Premium <br /> Decoration
            </p>
          </div>
          <div className="card1">
            {/* <img src="https://cheetah.cherishx.com/website_layout/120x86_Icons_Desktop_03_20240930_132612.jpg?format=avif" alt="" /> */}
             <img src={require("../../assets/images/forthcard.png")} />
            <p> Theme <br /> decoration</p>
          </div>
          <div
            className="card1"
            style={{ cursor: "pointer" }}
            onClick={() => handleCategory({ categoryName: "ANNIVERSARY" })}
          >
            {/* <img
              src="https://cheetah.cherishx.com/website_layout/1755170285__original_layout_55.jpg?format=avif"
              alt="Candlelight Dinner"
            /> */}
             <img src={require("../../assets/images/fifthcard.png")} />
            <p>
              Kids <br /> Party
            </p>
          </div>

          <div
            className="card1"
            style={{ cursor: "pointer" }}
            onClick={() => handleCategory({ categoryName: "BABY SHOWER" })}
          >
            {/* <img
              src="https://cheetah.cherishx.com/website_layout/120x86_Icons_Desktop_01_20241018_123157.jpg?format=avif"
              alt="Baby Shower"
            /> */}
             <img src={require("../../assets/images/sixthcard.png")} />
            <p>
              Room <br /> & Hall
            </p>
          </div>

          <div
            className="card1"
            style={{ cursor: "pointer" }}
            onClick={() => handleCategory({ categoryName: "BABY SHOWER" })}
          >
            {/* <img
              src="https://cheetah.cherishx.com/website_layout/120x86_Icons_Desktop_01_20241018_123157.jpg?format=avif"
              alt="Baby Shower"
            /> */}
             <img className="imgmat"src={require("../../assets/images/seventhcard.png")} />
            <p>
              Anniversary
            </p>
          </div>
          <div className="card1">
            {/* <img src="https://cheetah.cherishx.com/website_layout/120x86_Icons_Desktop_02_20241018_123157.jpg?format=avif" alt="" /> */}
             <img src={require("../../assets/images/eightcard.png")} />
            
            <p> Premium <br /> decoration</p>
          </div>
          <div className="card1">
            {/* <img src="https://cheetah.cherishx.com/website_layout/120x86_Icons_Desktop_08_20240930_132612.jpg?format=avif" alt="" /> */}
             <img className="imgmat"src={require("../../assets/images/ninthcard.png")} />
            <p> Balloon <br /> bouquet</p>
          </div>

          {/* NEW 10th CARD - Same Day Decorations */}
          <div
            className="card1"
            style={{ cursor: "pointer" }}
            onClick={() => handleCategory({ categoryName: "BIRTHDAY" })}
          >
            <img src={require("../../assets/images/td.png")} />
            <p>
              Same Day <br /> Decorations
            </p>
          </div>


        </div>
        <div id="carouselExampleIndicators" className="carousel slide">
          <div className="carousel-inner">
            {getTopBannerList?.data?.length > 0
              ? getTopBannerList?.data?.map((item, i) => {
                return (
                  <div className={`carousel-item ${i == 0 ? "active" : ""}`}>
                    <div>
                      <div className="HeroRight">
                        <img src={item?.bannerImage} />
                      </div>
                    </div>
                  </div>
                );
              })
              : ""}
          </div>
          <div className="carousel-indicators">
            {getTopBannerList?.data?.length > 0
              ? getTopBannerList?.data?.map((item, i) => {
                return (
                  <button
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={i}
                    className={`${i == 0 ? "active" : ""}`}
                    aria-current={`${i == 0 ? "true" : "false"}`}
                    aria-label={`Slide ${i + 1}`}
                  />
                );
              })
              : ""}
          </div>
        </div>
      </div>

      <div className="Main">
        <div className="FeatureArea">
          <div className="container-fluid" style={{ width: "100%", padding: "0", margin: "0" }}>
            <div className="section-title">
              <h2>Celebrations We Create</h2>
            </div>
            {/* <Slider {...settings}>
              {getCategoryList?.data?.length > 0
                ? getCategoryList?.data?.map((item, i) => {
                    return (
                      <div className="item" key={i}>
                        <div className="FeatureBoxMain">
                          <div className="FeatureBox">
                            <aside
                              style={{ cursor: "pointer" }}
                              onClick={() => handleCategory(item)}
                              className={
                                i == 0
                                  ? "Blue"
                                  : i == 1
                                  ? "Green"
                                  : i % 2 == 0
                                  ? "Orange"
                                  : i % 3 == 0
                                  ? "Cyan"
                                  : i % 4 == 0
                                  ? "Yellow"
                                  : i % 5 == 0
                                  ? "DarkGreen"
                                  : "Pink"
                              }
                            >
                              <figure>
                                <img src={item?.categoryImage} />
                              </figure>
                            </aside>
                            <h4
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content={item?.categoryName}
                            >
                              {item?.categoryName}
                            </h4>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : ""}
            </Slider> */}
            <div className="row">
              {getCategoryList?.data?.length > 0
                ? getCategoryList?.data?.map((item, i) => {
                  return (
                    <div className="col-lg-3 col-md-4 col-sm-6 col-6 top" key={i}>
                      <div className="FeatureBoxMain">
                        <div className="FeatureBox">
                          <aside
                            style={{ cursor: "pointer" }}
                            onClick={() => handleCategory(item)}
                            className={
                              i == 0
                                ? "Blue"
                                : i == 1
                                  ? "Green"
                                  : i % 2 == 0
                                    ? "Orange"
                                    : i % 3 == 0
                                      ? "Cyan"
                                      : i % 4 == 0
                                        ? "Yellow"
                                        : i % 5 == 0
                                          ? "DarkGreen"
                                          : "Pink"
                            }
                          >
                            <figure>
                              <img src={item?.categoryImage} />
                            </figure>
                          </aside>
                          <h4
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={item?.categoryName}
                          >
                            {item?.categoryName}
                          </h4>
                        </div>
                      </div>
                    </div>
                  );
                })
                : ""}
            </div>
          </div>
        </div>
        <div className="BirthdayDecorationArea">
          {/* <Slider {...settings1}> */}
          {getDealBannerList?.data?.length > 0
            ? getDealBannerList?.data?.map((item, i) => {
              if (item?.dealbannerTitle == "Birthday Decoration") {
                return (
                  <img
                    key={i}
                    src={item?.dealbannerImage}
                    onClick={() =>
                      handleCategory({ categoryName: "BIRTHDAY" })
                    }
                    style={{ cursor: "pointer" }}
                  />
                );
              }
            })
            : ""}
          {/* </Slider> */}
        </div>

        <ServiceCarousel />

        <div className="BirthdayDecorationArea BirthDecImage">
          <div className="container-fluid">
            <div className="section-title">
              <h2>Birthday Decoration</h2>
              <p>
                Transform Your Birthday into a Magical Celebration with Stunning
                Decorations!
              </p>
            </div>

            <div className="scroll-container-wrapper">
              {/* Left Arrow */}
              <div
                className="custom-arrow prev birthday-scroll-arrow"
                onClick={handleScrollLeft}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                  e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                  e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                }}
              >
                <i className="fa-solid fa-angle-left"></i>
              </div>

              {/* Right Arrow */}
              <div
                className="custom-arrow next birthday-scroll-arrow"
                onClick={handleScrollRight}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                  e.target.style.transform = 'translateY(-50%) scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                  e.target.style.transform = 'translateY(-50%) scale(1)';
                }}
              >
                <i className="fa-solid fa-angle-right"></i>
              </div>

              {/* Scrollable Content */}
              <div
                ref={scrollContainerRef}
                onScroll={handleScroll}
                className="birthday-scroll-container"
              >
                {getBirthdayList?.data?.length > 0 ? (
                  getBirthdayList?.data?.map((item, i) => {
                    return (
                      <div key={i} className="birthday-item">
                        <div className="PrivateDiningBox">
                          <figure>
                            <img
                              src={item?.productimages?.at(0)}
                              onClick={() => handleProduct(item)}
                              style={{ cursor: 'pointer' }}
                              alt={item?.productDetails?.productname}
                            />
                          </figure>
                          
                          <h6>{item?.productDetails?.productname}</h6>
                          
                          <div className="rightcard">
                            <div className="loc">
                              <h1>At your location</h1>
                            </div>
                            
                            <div className="Info">
                              <div className="text-right">
                                <div className="priceArea">
                                  {item?.priceDetails?.discountedPrice ? (
                                    <h5>
                                      ₹{item?.priceDetails?.discountedPrice}
                                      <span className="actualPrice">
                                        ₹{item?.priceDetails?.price}
                                      </span>
                                    </h5>
                                  ) : (
                                    <h5>₹{item?.priceDetails?.price}</h5>
                                  )}
                                  {item?.priceDetails?.discountedPrice && (
                                    <span>
                                      {Math.round(
                                        ((Number(item?.priceDetails?.price) -
                                          Number(item?.priceDetails?.discountedPrice)) /
                                          Number(item?.priceDetails?.price)) * 100
                                      )}% off
                                    </span>
                                  )}
                                </div>
                                <p>
                                  4.8 <i className="fa-solid fa-star"></i> |{" "}
                                  {i % 2 == 0 && i !== 0
                                    ? `${i % 2}` + 5 + i - 1
                                    : i == 0
                                      ? `14${i % 2}`
                                      : `${i % 2}` + 2 + i - 1}
                                </p>
                              </div>
                            </div>
                          </div>
                          
                          <div className="endbuttons">
                            <button
                              className="Buttons"
                              onClick={() => handleProduct(item)}
                            >
                              Book Now
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p>No item Available</p>
                )}
                
                {/* View All Button inside the scroller */}
                <div className="birthday-item view-all-item">
                  <div className="view-all-card" onClick={() => handleCategory({ categoryName: "BIRTHDAY" })}>
                    <div className="view-all-content">
                      <h6>View All Birthday Decorations</h6>
                      <div className="view-more-text">Explore more options</div>
                      <i className="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="BirthdayDecorationArea">
          {/* <Slider {...settings1}> */}
          {getDealBannerList?.data?.length > 0
            ? getDealBannerList?.data?.map((item, i) => {
              if (item?.dealbannerTitle == "Anniversary Decoration") {
                return (
                  <img
                    key={i}
                    src={item?.dealbannerImage}
                    onClick={() =>
                      handleCategory({ categoryName: "ANNIVERSARY" })
                    }
                    style={{ cursor: "pointer" }}
                  />
                );
              }
            })
            : ""}
          {/* </Slider> */}
        </div>

        <div className="BirthdayDecorationArea AnniDecImage">
          <div className="container-fluid">
            <div className="section-title">
              <h2>Anniversary Decoration</h2>
              <p>
                Celebrate Your Love with Elegant & Breathtaking Anniversary
                Decorations!
              </p>
            </div>

            <div className="scroll-container-wrapper">
              {/* Left Arrow */}
              <div
                className="custom-arrow prev anniversary-scroll-arrow"
                onClick={handleAnniversaryScrollLeft}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                  e.target.style.transform = 'translateY(-50%) scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                  e.target.style.transform = 'translateY(-50%) scale(1)';
                }}
              >
                <i className="fa-solid fa-angle-left"></i>
              </div>

              {/* Right Arrow */}
              <div
                className="custom-arrow next anniversary-scroll-arrow"
                onClick={handleAnniversaryScrollRight}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                  e.target.style.transform = 'translateY(-50%) scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                  e.target.style.transform = 'translateY(-50%) scale(1)';
                }}
              >
                <i className="fa-solid fa-angle-right"></i>
              </div>

              {/* Scrollable Content */}
              <div
                ref={anniversaryScrollRef}
                className="anniversary-scroll-container"
              >
                {getAnniversaryList?.data?.length > 0 ? (
                  getAnniversaryList?.data?.map((item, i) => {
                    return (
                      <div key={i} className="anniversary-item">
                        <div className="PrivateDiningBox">
                          <figure>
                            <img
                              src={item?.productimages?.at(0)}
                              onClick={() => handleProduct(item)}
                              style={{ cursor: 'pointer' }}
                              alt={item?.productDetails?.productname}
                            />
                          </figure>
                          
                          <h6>{item?.productDetails?.productname}</h6>
                          
                          <div className="rightcard">
                            <div className="loc">
                              <h1>At your location</h1>
                            </div>
                            
                            <div className="Info">
                              <div className="text-right">
                                <div className="priceArea">
                                  {item?.priceDetails?.discountedPrice ? (
                                    <h5>
                                      ₹{item?.priceDetails?.discountedPrice}
                                      <span className="actualPrice">
                                        ₹{item?.priceDetails?.price}
                                      </span>
                                    </h5>
                                  ) : (
                                    <h5>₹{item?.priceDetails?.price}</h5>
                                  )}
                                  {item?.priceDetails?.discountedPrice && (
                                    <span>
                                      {Math.round(
                                        ((Number(item?.priceDetails?.price) -
                                          Number(item?.priceDetails?.discountedPrice)) /
                                          Number(item?.priceDetails?.price)) * 100
                                      )}% off
                                    </span>
                                  )}
                                </div>
                                <p>
                                  4.8 <i className="fa-solid fa-star"></i> |{" "}
                                  {i % 2 == 0 && i !== 0
                                    ? `${i % 2}` + 5 + i - 1
                                    : i == 0
                                      ? `14${i % 2}`
                                      : `${i % 2}` + 2 + i - 1}
                                </p>
                              </div>
                            </div>
                          </div>
                          
                          <div className="endbuttons">
                            <button
                              className="Buttons"
                              onClick={() => handleProduct(item)}
                            >
                              Book Now
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p>No item Available</p>
                )}
                
                {/* View All Button inside the scroller */}
                <div className="anniversary-item view-all-item">
                  <div className="view-all-card" onClick={() => handleCategory({ categoryName: "ANNIVERSARY" })}>
                    <div className="view-all-content">
                      <h6>View All Anniversary Decorations</h6>
                      <div className="view-more-text">Explore more options</div>
                      <i className="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="BirthdayDecorationArea" style={{ cursor: "pointer" }}>
          {/* <Slider {...settings1}> */}
          {getDealBannerList?.data?.length > 0
            ? getDealBannerList?.data?.map((item, i) => {
              if (item?.dealbannerTitle == "Kids Party") {
                return (
                  <img
                    key={i}
                    src={item?.dealbannerImage}
                    onClick={() =>
                      handleCategory({ categoryName: "KID'S PARTY" })
                    }
                  />
                );
              }
            })
            : ""}
          {/* </Slider> */}
        </div>

        <div className="BirthdayDecorationArea BirthDecImage">
          <div className="container-fluid">
            <div className="section-title">
              <h2>Kid's Party</h2>
              <p>
                Turn Your Kid's Party into a Whimsical Wonderland of Fun &
                Magic!
              </p>
            </div>

            <div className="scroll-container-wrapper">
              {/* Left Arrow */}
              <div
                className="custom-arrow prev kids-scroll-arrow"
                onClick={handleKidsScrollLeft}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                  e.target.style.transform = 'translateY(-50%) scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                  e.target.style.transform = 'translateY(-50%) scale(1)';
                }}
              >
                <i className="fa-solid fa-angle-left"></i>
              </div>

              {/* Right Arrow */}
              <div
                className="custom-arrow next kids-scroll-arrow"
                onClick={handleKidsScrollRight}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                  e.target.style.transform = 'translateY(-50%) scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                  e.target.style.transform = 'translateY(-50%) scale(1)';
                }}
              >
                <i className="fa-solid fa-angle-right"></i>
              </div>

              {/* Scrollable Content */}
              <div
                ref={kidsScrollRef}
                className="kids-scroll-container"
              >
                {getKidsList?.data?.length > 0 ? (
                  getKidsList?.data?.map((item, i) => {
                    return (
                      <div key={i} className="kids-item">
                        <div className="PrivateDiningBox">
                          <figure>
                            <img
                              src={item?.productimages?.at(0)}
                              onClick={() => handleProduct(item)}
                              style={{ cursor: 'pointer' }}
                              alt={item?.productDetails?.productname}
                            />
                          </figure>
                          
                          <h6>{item?.productDetails?.productname}</h6>
                          
                          <div className="rightcard">
                            <div className="loc">
                              <h1>At your location</h1>
                            </div>
                            
                            <div className="Info">
                              <div className="text-right">
                                <div className="priceArea">
                                  {item?.priceDetails?.discountedPrice ? (
                                    <h5>
                                      ₹{item?.priceDetails?.discountedPrice}
                                      <span className="actualPrice">
                                        ₹{item?.priceDetails?.price}
                                      </span>
                                    </h5>
                                  ) : (
                                    <h5>₹{item?.priceDetails?.price}</h5>
                                  )}
                                  {item?.priceDetails?.discountedPrice && (
                                    <span>
                                      {Math.round(
                                        ((Number(item?.priceDetails?.price) -
                                          Number(item?.priceDetails?.discountedPrice)) /
                                          Number(item?.priceDetails?.price)) * 100
                                      )}% off
                                    </span>
                                  )}
                                </div>
                                <p>
                                  4.8 <i className="fa-solid fa-star"></i> |{" "}
                                  {i % 2 == 0 && i !== 0
                                    ? `${i % 2}` + 5 + i - 1
                                    : i == 0
                                      ? `14${i % 2}`
                                      : `${i % 2}` + 2 + i - 1}
                                </p>
                              </div>
                            </div>
                          </div>
                          
                          <div className="endbuttons">
                            <button
                              className="Buttons"
                              onClick={() => handleProduct(item)}
                            >
                              Book Now
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p>No item Available</p>
                )}
                
                {/* View All Button inside the scroller */}
                <div className="kids-item view-all-item">
                  <div className="view-all-card" onClick={() => handleCategory({ categoryName: "KID'S PARTY" })}>
                    <div className="view-all-content">
                      <h6>View All Kids Party Decorations</h6>
                      <div className="view-more-text">Explore more options</div>
                      <i className="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="BirthdayDecorationArea" style={{ cursor: "pointer" }}>
          {/* <Slider {...settings1}> */}
          {getDealBannerList?.data?.length > 0
            ? getDealBannerList?.data?.map((item, i) => {
              if (item?.dealbannerTitle == "Baby Shower") {
                return (
                  <img
                    key={i}
                    src={item?.dealbannerImage}
                    onClick={() =>
                      handleCategory({ categoryName: "BABY SHOWER" })
                    }
                  />
                );
              }
            })
            : ""}
          {/* </Slider> */}
        </div>

        <div className="BirthdayDecorationArea AnniDecImage">
          <div className="container-fluid">
            <div className="section-title">
              <h2>Baby Shower</h2>
              <p>
                Celebrate the Joy of New Beginnings with Enchanting Baby Shower
                Decor!
              </p>
            </div>

            <div className="scroll-container-wrapper">
              {/* Left Arrow */}
              <div
                className="custom-arrow prev baby-shower-scroll-arrow"
                onClick={handleBabyShowerScrollLeft}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                  e.target.style.transform = 'translateY(-50%) scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                  e.target.style.transform = 'translateY(-50%) scale(1)';
                }}
              >
                <i className="fa-solid fa-angle-left"></i>
              </div>

              {/* Right Arrow */}
              <div
                className="custom-arrow next baby-shower-scroll-arrow"
                onClick={handleBabyShowerScrollRight}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                  e.target.style.transform = 'translateY(-50%) scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                  e.target.style.transform = 'translateY(-50%) scale(1)';
                }}
              >
                <i className="fa-solid fa-angle-right"></i>
              </div>

              {/* Scrollable Content */}
              <div
                ref={babyShowerScrollRef}
                className="baby-shower-scroll-container"
              >
                {getWeddingDecoList?.data?.length > 0 ? (
                  getWeddingDecoList?.data?.map((item, i) => {
                    return (
                      <div key={i} className="baby-shower-item">
                        <div className="PrivateDiningBox">
                          <figure>
                            <img
                              src={item?.productimages?.at(0)}
                              onClick={() => handleProduct(item)}
                              style={{ cursor: 'pointer' }}
                              alt={item?.productDetails?.productname}
                            />
                          </figure>
                          
                          <h6>{item?.productDetails?.productname}</h6>
                          
                          <div className="rightcard">
                            <div className="loc">
                              <h1>At your location</h1>
                            </div>
                            
                            <div className="Info">
                              <div className="text-right">
                                <div className="priceArea">
                                  {item?.priceDetails?.discountedPrice ? (
                                    <h5>
                                      ₹{item?.priceDetails?.discountedPrice}
                                      <span className="actualPrice">
                                        ₹{item?.priceDetails?.price}
                                      </span>
                                    </h5>
                                  ) : (
                                    <h5>₹{item?.priceDetails?.price}</h5>
                                  )}
                                  {item?.priceDetails?.discountedPrice && (
                                    <span>
                                      {Math.round(
                                        ((Number(item?.priceDetails?.price) -
                                          Number(item?.priceDetails?.discountedPrice)) /
                                          Number(item?.priceDetails?.price)) * 100
                                      )}% off
                                    </span>
                                  )}
                                </div>
                                <p>
                                  4.8 <i className="fa-solid fa-star"></i> |{" "}
                                  {i % 2 == 0 && i !== 0
                                    ? `${i % 2}` + 5 + i - 1
                                    : i == 0
                                      ? `14${i % 2}`
                                      : `${i % 2}` + 2 + i - 1}
                                </p>
                              </div>
                            </div>
                          </div>
                          
                          <div className="endbuttons">
                            <button
                              className="Buttons"
                              onClick={() => handleProduct(item)}
                            >
                              Book Now
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p>No item Available</p>
                )}
                
                {/* View All Button inside the scroller */}
                <div className="baby-shower-item view-all-item">
                  <div className="view-all-card" onClick={() => handleCategory({ categoryName: "BABY SHOWER" })}>
                    <div className="view-all-content">
                      <h6>View All Baby Shower Decorations</h6>
                      <div className="view-more-text">Explore more options</div>
                      <i className="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="BirthdayDecorationArea">
          <img src={require("../../assets/images/Photos 1.png")} />
        </div>
        <article>
          <img
            style={{ margin: "10px 0" }}
            src={require("../../assets/images/stats 2.png")}
          />
        </article>


        {/* ===== CUSTOMER REVIEWS SECTION ===== */}
        <div className="reviews-section">
          <div className="container">
            <div className="reviews-header">
              <h1>What Customers Say</h1>
              <p>Genuine feedback from our delighted customers who trusted us with their special moments</p>
            </div>
            {latestReviews.length === 0 ? (
              <div className="testimonials-container">
                <button className="testimonial-nav-btn prev" onClick={handleReviewsScrollLeft}>
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <div className="testimonials-slider" ref={reviewsScrollRef}>
                  {/* Sample reviews with better names */}
                  {[
                    { name: "Priya Sharma", rating: 5, comment: "Absolutely amazing birthday decoration! The team was professional and the setup was beyond our expectations.", productName: "Birthday Decoration Premium", userImage: "https://images.unsplash.com/photo-1494790108755-2616b612b739?w=150&h=150&fit=crop&crop=face" },
                    { name: "Rahul Patel", rating: 4, comment: "Great service for our anniversary celebration. The balloon arrangements were beautiful and exactly what we wanted.", productName: "Anniversary Special", userImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face" },
                    { name: "Sneha Verma", rating: 5, comment: "Perfect decoration for our baby shower! Every detail was taken care of and the colors were just perfect.", productName: "Baby Shower Deluxe", userImage: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face" },
                    { name: "Arjun Singh", rating: 4, comment: "Excellent work on our wedding decoration. The team was punctual and very creative with their designs.", productName: "Wedding Decoration", userImage: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face" },
                    { name: "Kavya Reddy", rating: 5, comment: "Outstanding birthday surprise setup! My daughter was absolutely delighted. Highly recommend their services.", productName: "Kids Birthday Special", userImage: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face" },
                    { name: "Vikram Joshi", rating: 5, comment: "Fantastic decoration for our office party. Professional team and beautiful execution. Will definitely use again!", productName: "Corporate Event", userImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face" }
                  ].map((review, index) => (
                    <div key={index} className="testimonial-card">
                      <div className="testimonial-header">
                        <div className="customer-info">
                          <div className="customer-avatar">
                            <img src={review.userImage} alt={review.name} />
                          </div>
                          <div className="customer-details">
                            <h3>{review.name}</h3>
                            <div className="rating-stars">
                              {[...Array(5)].map((_, i) => (
                                <i 
                                  key={i} 
                                  className={`fa-solid fa-star ${i < review.rating ? 'filled' : ''}`}
                                ></i>
                              ))}
                              <span className="rating-text">({review.rating}/5)</span>
                            </div>
                          </div>
                        </div>
                        <div className="verified-badge">
                          <i className="fa-solid fa-badge-check"></i>
                          <span>Verified</span>
                        </div>
                      </div>
                      <div className="testimonial-content">
                        <p>"{review.comment}"</p>
                      </div>
                      <div className="product-info">
                        <div className="product-tag">
                          <i className="fa-solid fa-gift"></i>
                          <span>{review.productName}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <button className="testimonial-nav-btn next" onClick={handleReviewsScrollRight}>
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            ) : (
              <div className="testimonials-container">
                <button className="testimonial-nav-btn prev" onClick={handleReviewsScrollLeft}>
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <div className="testimonials-slider" ref={reviewsScrollRef}>
                  {latestReviews.map((review, index) => (
                    <div key={index} className="testimonial-card">
                      <div className="testimonial-header">
                        <div className="customer-info">
                          <div className="customer-avatar">
                            <img src={review.userImage || "https://cdn-icons-png.flaticon.com/512/6681/6681204.png"} alt={review.name} />
                          </div>
                          <div className="customer-details">
                            <h3>{review.name}</h3>
                            <div className="rating-stars">
                              {[...Array(5)].map((_, i) => (
                                <i 
                                  key={i} 
                                  className={`fa-solid fa-star ${i < review.rating ? 'filled' : ''}`}
                                ></i>
                              ))}
                              <span className="rating-text">({review.rating}/5)</span>
                            </div>
                          </div>
                        </div>
                        <div className="verified-badge">
                          <i className="fa-solid fa-badge-check"></i>
                          <span>Verified</span>
                        </div>
                      </div>
                      <div className="testimonial-content">
                        <p>"{review.comment}"</p>
                      </div>
                      <div className="product-info">
                        <div className="product-tag">
                          <i className="fa-solid fa-gift"></i>
                          <span>{review.productName}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <button className="testimonial-nav-btn next" onClick={handleReviewsScrollRight}>
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="about-section">
          <h1>
            <strong> Skyrixe – Celebrate Life’s Special Moments with us
              Us&nbsp;&nbsp;&nbsp;</strong>
          </h1>
          <p>
            <span>Each celebratory occasion needs a unique touch of excellence.
              Skyrixe&nbsp; devotes itself to providing memorable experiences for every
              moment. Do you&nbsp; remember the last time you got services tailored for
              you? Neither can we, and that’s exactly why we go above and beyond
              every single time, making sure that every service we offer is truly
              remarkable. With our setup services, every special moment can come to life.
              We provide romantic dinners and simple birthday decorations.</span>
          </p>
          <p className='second'>
            <span>In our ten years of operation, we have held many events across India. We
              have served thousands of customers as they created special memories. Our
              dedicated team creates impressive event experiences for our customers. We
              enhance celebrations with balloon decorations and themed party decor. We
              cater to both small home events and large banquet functions.</span>
          </p>
          <h2>
            <strong>Our Services – Fully Customizable For Your Every Event</strong>
          </h2>
          <p>
            <span>Every event requires a personalized touch to be unique. Skyrixe provides
              decoration solutions for basic birthday arrangements, anniversary
              decorations, and complete surprise party preparations. Our deep experience
              with multiple event decoration services enhances your special moments on all
              occasions.</span>
          </p>
          <div className="city-links">
  <a href="#">Balloon decoration in Bangalore</a> |
  <a href="#">Balloon decoration in Bhubaneswar</a> |
  <a href="#">Balloon decoration in Chennai</a> |
  <a href="#">Balloon decoration in Delhi</a> |
  <a href="#">Balloon decoration in Gurgaon</a> |
  <a href="#">Balloon decoration in Hyderabad</a> |
  <a href="#">Balloon decoration in Mumbai</a> |
  <a href="#">Balloon decoration in Pune</a> |
  <a href="#">Balloon decoration in Kolkata</a> |
  <a href="#">Balloon decoration in Noida</a> |
  <a href="#">Balloon decoration in Patna</a>
</div>

        </div>

        {/* ===== FAQ SECTION ===== */}
        <div className="faq-section-enhanced">
          <div className="container">
            <div className="section-title">
              <h2>Frequently Asked Questions</h2>
              <p>Everything you need to know about our decoration services</p>
            </div>
            
            <div className="faq-grid">
              <div className={`faq-item ${activeFaq === 0 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => handleFaqToggle(0)}>
                  <h3>What kind of events do you provide your decorations for?</h3>
                  <div className="faq-toggle">
                    <i className="fa-solid fa-plus"></i>
                  </div>
                </div>
                <div className="faq-answer">
                  <p>We provide decorations for all types of celebrations including birthdays, weddings, anniversaries, baby showers, corporate events, housewarming parties, engagement ceremonies, and festival celebrations. Our team specializes in creating magical moments for every occasion.</p>
                </div>
              </div>
              
              <div className={`faq-item ${activeFaq === 1 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => handleFaqToggle(1)}>
                  <h3>How do we book a service with you?</h3>
                  <div className="faq-toggle">
                    <i className="fa-solid fa-plus"></i>
                  </div>
                </div>
                <div className="faq-answer">
                  <p>Booking is easy! You can book through our website, call us directly, message us on WhatsApp, or reach out via our social media channels. Our team will guide you through the entire process and help customize your perfect celebration.</p>
                </div>
              </div>
              
              <div className={`faq-item ${activeFaq === 2 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => handleFaqToggle(2)}>
                  <h3>How much does simple birthday decoration cost?</h3>
                  <div className="faq-toggle">
                    <i className="fa-solid fa-plus"></i>
                  </div>
                </div>
                <div className="faq-answer">
                  <p>Our simple birthday decoration packages start from ₹2,999 and can go up to ₹15,000+ depending on your requirements. We offer various packages to suit different budgets and preferences. Contact us for a personalized quote.</p>
                </div>
              </div>
              
              <div className={`faq-item ${activeFaq === 3 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => handleFaqToggle(3)}>
                  <h3>In which cities is Skyrixe available?</h3>
                  <div className="faq-toggle">
                    <i className="fa-solid fa-plus"></i>
                  </div>
                </div>
                <div className="faq-answer">
                  <p>We currently serve major cities including Bangalore, Mumbai, Delhi, Chennai, Hyderabad, Pune, Kolkata, Gurgaon, Noida, Bhubaneswar, and Patna. We're continuously expanding to serve more cities across India.</p>
                </div>
              </div>
              
              <div className={`faq-item ${activeFaq === 4 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => handleFaqToggle(4)}>
                  <h3>Do you provide same-day decoration services?</h3>
                  <div className="faq-toggle">
                    <i className="fa-solid fa-plus"></i>
                  </div>
                </div>
                <div className="faq-answer">
                  <p>Yes, we offer same-day decoration services based on availability. However, we recommend booking at least 24-48 hours in advance to ensure we can accommodate your specific requirements and preferences.</p>
                </div>
              </div>
              
              <div className={`faq-item ${activeFaq === 5 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => handleFaqToggle(5)}>
                  <h3>Can I customize the decoration according to my theme?</h3>
                  <div className="faq-toggle">
                    <i className="fa-solid fa-plus"></i>
                  </div>
                </div>
                <div className="faq-answer">
                  <p>Absolutely! We specialize in custom decorations. Share your theme, color preferences, and specific requirements with our team, and we'll create a unique decoration setup tailored to your vision and budget.</p>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="BirthdayDecorationArea client">

          <img src={require("../../assets/images/Our Clients.png")} />


        </div>
      </div >
      <Tooltip id="my-tooltip" place="bottom" />
    </>
  );
};

export default Main;
